import { SiteCategory } from '../models/site-category.model';

export const siteNavigation: { [key: string]: SiteCategory[] } = {
  main: [{
    'title': 'All Models',
    'id': 'all',
    'type': 'Category',
    'translations': {
      'es': {
        'title': 'Todas las Categorías'
      },
      'zh': {
        'title': '所有类别'
      },
      'fr': {
        'title': 'Toutes les catégories'
      },
      'de': {
        'title': 'Alle Kategorien'
      },
      'it': {
        'title': 'Tutte le categorie'
      },
      'ja': {
        'title': 'すべてのカテゴリ'
      },
      'pt': {
        'title': 'Todas as categorias'
      }
    }
  }],
  categories: [
    {
      'title': 'Anatomy by Regions',
      'id': 'regional',
      'type': 'Category',
      'translations': {
        'es': {
          'title': 'Anatomía por Regiones'
        },
        'zh': {
          'title': '按地区划分的解剖学'
        },
        'fr': {
          'title': 'Anatomie par régions'
        },
        'de': {
          'title': 'Anatomie nach Regionen'
        },
        'it': {
          'title': 'Anatomia per regioni'
        },
        'ja': {
          'title': '地域別解剖学'
        },
        'pt': {
          'title': 'Anatomia por Regiões'
        }
      }
    },
    {
      'title': 'Anatomy by Systems',
      'id': 'system',
      'type': 'Category',
      'translations': {
        'es': {
          'title': 'Anatomía por Sistemas'
        },
        'zh': {
          'title': '按系统进行解剖学'
        },
        'fr': {
          'title': 'Anatomie par systèmes'
        },
        'de': {
          'title': 'Anatomie nach Systemen'
        },
        'it': {
          'title': 'Anatomia per sistemi'
        },
        'ja': {
          'title': 'システムによる解剖学'
        },
        'pt': {
          'title': 'Anatomia por Sistemas'
        }
      }
    },
    {
      'title': 'Complete Anatomy',
      'id': 'complete anatomy',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Komplette Anatomie'
        },
        'es': {
          'title': 'Anatomía completa'
        },
        'fr': {
          'title': 'Anatomie complète'
        },
        'it': {
          'title': 'Anatomia completa'
        },
        'ja': {
          'title': '完全な解剖学'
        },
        'pt': {
          'title': 'Anatomia Completa'
        },
        'zh': {
          'title': '完整解剖学'
        }
      }
    },
    {
      'title': 'Cross Sections & Micro Anatomy',
      'id': 'Cross Section and Micro Anatomy',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Querschnitte & Mikro-Anatomie'
        },
        'es': {
            'title': 'Secciones transversales y Micro Anatomía'
        },
        'fr': {
            'title': 'Sections transversales et micro anatomie'
        },
        'it': {
            'title': 'Sezioni trasversali & Micro Anatomia'
        },
        'ja': {
            'title': '断面＆マイクロ解剖学'
        },
        'pt': {
            'title': 'Seções Transversais e Micro Anatomia'
        },
        'zh': {
            'title': '截面和微型解剖学'
        }
      }
    },
  ],
  specialties: [
    {
      'title': 'Allergy & Immunology',
      'id': 'Allergy and Immunology',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Allergie und Immunologie'
        },
        'es': {
          'title': 'Alergia e Inmunología'
        },
        'fr': {
          'title': 'Allergie et Immunologie'
        },
        'it': {
          'title': 'Allergia e Immunologia'
        },
        'ja': {
          'title': 'アレルギーと免疫学'
        },
        'pt': {
          'title': 'Alergia e Imunologia'
        },
        'zh': {
          'title': '过敏与免疫学'
        }
      }
    },
    {
      'title': 'Cardiology',
      'id': 'Cardiology',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Kardiologie'
        },
        'es': {
          'title': 'Cardiología'
        },
        'fr': {
          'title': 'Cardiologie'
        },
        'it': {
          'title': 'Cardiologia'
        },
        'ja': {
          'title': '心臓病学'
        },
        'pt': {
          'title': 'Cardiologia'
        },
        'zh': {
          'title': '心脏病学'
        }
      }
    },
    {
      'title': 'Dentistry',
      'id': 'Dentistry',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Zahnmedizin'
        },
        'es': {
          'title': 'Odontología'
        },
        'fr': {
          'title': 'Dentisterie'
        },
        'it': {
          'title': 'Odontoiatria'
        },
        'ja': {
          'title': '歯科'
        },
        'pt': {
          'title': 'Odontologia'
        },
        'zh': {
          'title': '牙科'
        }
      }
    },
    {
      'title': 'Dermatology',
      'id': 'Dermatology',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Dermatologie'
        },
        'es': {
          'title': 'Dermatología'
        },
        'fr': {
          'title': 'Dermatologie'
        },
        'it': {
          'title': 'Dermatologia'
        },
        'ja': {
          'title': '皮膚科'
        },
        'pt': {
          'title': 'Dermatologia'
        },
        'zh': {
          'title': '皮肤科'
        }
      }
    },
    {
      'title': 'Endocrinology',
      'id': 'Endocrinology',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Endokrinologie'
        },
        'es': {
          'title': 'Endocrinología'
        },
        'fr': {
          'title': 'Endocrinologie'
        },
        'it': {
          'title': 'Endocrinologia'
        },
        'ja': {
          'title': '内分泌内科'
        },
        'pt': {
          'title': 'Endocrinologia'
        },
        'zh': {
          'title': '内分泌学'
        }
      }
    },
    {
      'title': 'Gastroenterology',
      'id': 'Gastroenterology and Hepatology',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Gastroenterologie'
        },
        'es': {
          'title': 'Gastroenterología'
        },
        'fr': {
          'title': 'Gastroentérologie'
        },
        'it': {
          'title': 'Gastroenterologia'
        },
        'ja': {
          'title': '消化器内科'
        },
        'pt': {
          'title': 'Gastroenterologia'
        },
        'zh': {
          'title': '胃肠病学'
        }
      }
    },
    {
      'title': 'Infectious Disease',
      'id': 'Infectious Disease',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Infektionskrankheit'
        },
        'es': {
          'title': 'Enfermedades Infecciosas'
        },
        'fr': {
          'title': 'Maladies infectieuses'
        },
        'it': {
          'title': 'Malattie Infettive'
        },
        'ja': {
          'title': '感染症'
        },
        'pt': {
          'title': 'Doença Infecciosa'
        },
        'zh': {
          'title': '传染病'
        }
      }
    },
    {
      'title': 'Nephrology',
      'id': 'Nephrology',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Nephrologie'
        },
        'es': {
          'title': 'Nefrología'
        },
        'fr': {
          'title': 'Néphrologie'
        },
        'it': {
          'title': 'Nefrologia'
        },
        'ja': {
          'title': '腎学'
        },
        'pt': {
          'title': 'Nefrologia'
        },
        'zh': {
          'title': '肾脏病学'
        }
      }
    },
    {
      'title': 'Neurology & Psychiatry',
      'id': 'Neurology and Psychiatry',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Neurologie & Psychiatrie'
        },
        'es': {
          'title': 'Neurología y Psiquiatría'
        },
        'fr': {
          'title': 'Neurologie & Psychiatrie'
        },
        'it': {
          'title': 'Neurologia & Psichiatria'
        },
        'ja': {
          'title': '神経内科・精神科'
        },
        'pt': {
          'title': 'Neurologia e Psiquiatria'
        },
        'zh': {
          'title': '神经学和精神病学'
        }
      }
    },
    {
      'title': 'Obstetrics & Gynecology',
      'id': 'Obstetrics and Gynecology',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Geburtshilfe & Gynäkologie'
        },
        'es': {
          'title': 'Obstetricia y Ginecología'
        },
        'fr': {
          'title': 'Obstétrique et gynécologie'
        },
        'it': {
          'title': 'Ostetricia & Ginecologia'
        },
        'ja': {
          'title': '産婦人科'
        },
        'pt': {
          'title': 'Obstetrícia e Ginecologia'
        },
        'zh': {
          'title': '妇产科'
        }
      }
    },
    {
      'title': 'Hematology & Oncology',
      'id': 'Oncology and Hematology',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Hämatologie/Onkologie'
        },
        'es': {
          'title': 'Hematología/Oncología'
        },
        'fr': {
          'title': 'Hématologie/Oncologie'
        },
        'it': {
          'title': 'Ematologia/Oncologia'
        },
        'ja': {
          'title': '血液学・腫瘍学'
        },
        'pt': {
          'title': 'Hematologia/Oncologia'
        },
        'zh': {
          'title': '血液学/肿瘤学'
        }
      }
    },
    {
      'title': 'Ophthalmology',
      'id': 'Ophthalmology',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Ophthalmologie'
        },
        'es': {
          'title': 'Oftalmología'
        },
        'fr': {
          'title': 'Ophtalmologie'
        },
        'it': {
          'title': 'Oftalmologia'
        },
        'ja': {
          'title': '眼科か'
        },
        'pt': {
          'title': 'Oftalmologia'
        },
        'zh': {
          'title': '眼科'
        }
      }
    },
    {
      'title': 'Orthopedics',
      'id': 'Orthopedics',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Orthopädie'
        },
        'es': {
          'title': 'Ortopedia'
        },
        'fr': {
          'title': 'Orthopédie'
        },
        'it': {
          'title': 'Ortopedia'
        },
        'ja': {
          'title': '整形外科'
        },
        'pt': {
          'title': 'Ortopedia'
        },
        'zh': {
          'title': '整形外科'
        }
      }
    },
    {
      'title': 'Otolaryngology',
      'id': 'Otolaryngology',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'HNO-Heilkunde'
        },
        'es': {
          'title': 'Otorrinolaringología'
        },
        'fr': {
          'title': 'Otorhinolaryngologie'
        },
        'it': {
          'title': 'Otorinolaringoiatria'
        },
        'ja': {
          'title': '耳鼻咽喉科'
        },
        'pt': {
          'title': 'Otorrinolaringologia'
        },
        'zh': {
          'title': '耳鼻喉科'
        }
      }
    },
    {
      'title': 'Pediatrics',
      'id': 'Pediatrics',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Pädiatrie'
        },
        'es': {
          'title': 'Pediatría'
        },
        'fr': {
          'title': 'Pédiatrie'
        },
        'it': {
          'title': 'Pediatria'
        },
        'ja': {
          'title': '小児科'
        },
        'pt': {
          'title': 'Pediatria'
        },
        'zh': {
          'title': '儿科'
        }
      }
    },
    {
      'title': 'Pulmonology',
      'id': 'Pulmonology and Respiratory',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Pulmonologie'
        },
        'es': {
          'title': 'Neumología'
        },
        'fr': {
          'title': 'Pneumologie'
        },
        'it': {
          'title': 'Pneumologia'
        },
        'ja': {
          'title': '肺'
        },
        'pt': {
          'title': 'Pneumologia'
        },
        'zh': {
          'title': '呼吸学'
        }
      }
    },
    {
      'title': 'Rheumatology',
      'id': 'Rheumatology',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Rheumatologie'
        },
        'es': {
          'title': 'Reumatología'
        },
        'fr': {
          'title': 'Rhumatologie'
        },
        'it': {
          'title': 'Reumatologia'
        },
        'ja': {
          'title': 'リウマチ科'
        },
        'pt': {
          'title': 'Reumatologia'
        },
        'zh': {
          'title': '风湿病学'
        }
      }
    },
    {
      'title': 'Urology',
      'id': 'Urology',
      'type': 'Category',
      'translations': {
        'de': {
          'title': 'Urologie'
        },
        'es': {
          'title': 'Urología'
        },
        'fr': {
          'title': 'Urologie'
        },
        'it': {
          'title': 'Urologia'
        },
        'ja': {
          'title': '泌尿器科か'
        },
        'pt': {
          'title': 'Urologia'
        },
        'zh': {
          'title': '泌尿外科'
        }
      }
    },
    {
      'title': 'Community Bookmarks',
      'id': 'public',
      'type': 'Community',
      'translations': {
        'de': {
          'title': 'Community-Lesezeichen'
        },
        'es': {
          'title': 'Marcadores de la comunidad'
        },
        'fr': {
          'title': 'Signets communautaires'
        },
        'it': {
          'title': 'Segnalibri della community'
        },
        'ja': {
          'title': 'コミュニティのブックマーク'
        },
        'pt': {
          'title': 'Favoritos da comunidade'
        },
        'zh': {
          'title': '社区书签'
        }
      }
    }
  ]
};
